import {combineReducers} from "redux";
import forgot from "features/pages/account/forgot-password/reducer";
import login from "features/pages/account/login/reducer";
import temp_password from "features/pages/account/temp-password/reducer";
import signup from "features/pages/account/signup/reducer";
import onboarding from "features/pages/account/onboarding/reducer";
import change_password from "features/modals/change-password/reducer";
import delete_account from "features/modals/delete-account/reducer";
import reset_password from "features/pages/account/reset-password/reducer";

export default combineReducers({
    forgot,
    login,
    temp_password,
    signup,
    onboarding,
    change_password,
    delete_account,
    reset_password
});